export default __webpack_public_path__ + "static/testimonials-bg-bl-7c2ef54dbb31eb52190b20ff92daf4cd.svg";